<template>
  <ckeditor v-model="val" v-if="componentStatus" :id="id" :name="name" types="full" :class="{className: true}" :config="ckconfig"></ckeditor>
</template>

<script>
import Ckeditor from 'vue-ckeditor2'

export default {
	props: {
		name: String,
		id: String,
		className: String,
		value: {
			type: String,
			required: false,
			default: null
		}
	},
	components: {
		Ckeditor
	},
	data: function() {
		return {
			componentStatus: true,
			text: null,
			ckconfig: {
				height: 300,
				defaultLanguage: 'es',
				uiColor: '#FFFFFF',
				format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
				toolbar: [['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '|', 'RemoveFormat'], ['NumberedList', 'BulletedList', '|', 'Outdent', 'Indent', '|', 'Blockquote'], ['Cut', 'Copy', 'Paste'], ['Link', 'Unlink'], ['Maximize'], ['Image'], ['TextColor'], ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'], { name: 'styles', items: ['Styles', 'Format'] }],
				extraPlugins: 'justify,colorbutton,imageuploader,floatpanel,panelbutton,button,panel',
				filebrowserImageBrowseUrl: '/#/ckeditor-browser/?type=Images',
				filebrowserWindowWidth: '640',
				filebrowserWindowHeight: '480'
			}
		}
	},
	created: function() {
		this.text = this.value
	},
	watch: {
		'$route.path': function() {
			this.componentStatus = false
			setTimeout(() => {
				this.componentStatus = true
			}, 200)
		},
		value: function() {
			this.text = this.value
		},
		val: function() {
			this.$emit('input', this.val)
		}
	},
	computed: {
		val: {
			get: function() {
				return this.text
			},
			set: function(data) {
				this.text = data
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/helpers/ckeditor/editor.vue